import '.bx{position:relative;}.ssr-plugin'
import '.il{width:64px;}.ssr-plugin'
import '.im{height:64px;}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.b4{position:absolute;}.ssr-plugin'
import '.in{bottom:-4px;}.ssr-plugin'
import '.hn{right:-4px;}.ssr-plugin'
import '.da{border-radius:50%;}.ssr-plugin'
import '.io{border:2px solid var(--palette-white);}.ssr-plugin'
import '.ag{overflow:hidden;}.ssr-plugin'
import '.ip{width:32px;}.ssr-plugin'
import '.iq{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bx il im bn"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="b4 in hn da io ag ip iq"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
